<template>
  <suspicious-activity-review-container />
</template>

<script>
import { SuspiciousActivityReviewContainer } from '@/modules/suspicious-activity-review'

export default {
  components: {
    SuspiciousActivityReviewContainer
  }
}
</script>
